import { Flex, Title } from '@mantine/core';
import { fetchAdminIssues, fetchAdminIssuesArchived, fetchAdminSites, useAppDispatch, useAppSelector } from 'src/store';
import { shallowEqual } from 'react-redux';
import { FC, Fragment, useEffect, useState } from 'react';
import { ReportedSiteList } from 'src/components';
import { useTranslation } from 'react-i18next';
import { FilterAdminIssues } from 'src/components/filters';

const Reports: FC = () => {
  const [t] = useTranslation('reports');
  const dispatch = useAppDispatch();
  const adminIssues = useAppSelector((state) => state.adminIssues.data?.items, shallowEqual);
  const adminIssuesArchived = useAppSelector((state) => state.adminIssues.archived?.items, shallowEqual);
  const [isActiveFilter, setIsActiveFilter] = useState<boolean>(false);
  const allIssues = [...(adminIssues || []), ...(adminIssuesArchived || [])];

  useEffect(() => {
    dispatch(fetchAdminIssues());
    dispatch(fetchAdminIssuesArchived());
    dispatch(fetchAdminSites());
  }, []);

  return (
    <Flex style={{ flexGrow: 1 }} direction={'column'} bg={'#F6FAFA'} my={0} px={24} py={24}>
      <Title color="#264547" order={1} id={'mainContent'} pb={14}>
        {t('reportsList')}
      </Title>
      {adminIssues?.length === 0 && adminIssuesArchived?.length === 0 && !isActiveFilter ? (
        <Fragment>{t('noData')}</Fragment>
      ) : (
        <Fragment>
          <FilterAdminIssues onIsActive={(v) => setIsActiveFilter(v)} />
          <ReportedSiteList userRole={'superadmin'} adminIssues={allIssues} />
        </Fragment>
      )}
    </Flex>
  );
};

export default Reports;
